import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch} from 'react-redux';
import { userActions, alertActions } from '../../../actions';
import { validation } from '../../../shared/form-validations';
import { textInput, PasswordInput } from '../../../shared/form-elements'
import { reduxForm, Field, change } from "redux-form";
import { Button, Col, Row } from 'react-bootstrap';
import { LoginHeader } from '../LayoutPage/loginHeader';
import { Image, isLoggedIn } from '../../../utils';
import { AlertText } from '../../../components';
import { history } from '../../../helpers';
import { userConstants } from '../../../constants';
import { Helmet } from "react-helmet";
import Topbar from '../../../components/public/Topbar';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import ReCAPTCHA from "react-google-recaptcha";
import useRecaptchaV2Hook from 'hooks/useRecaptchaV2Hook';

function RregisterForm(props) {
  const { handleSubmit } = props
  const dispatch = useDispatch();
  const query = new URLSearchParams(props.location.search.replace(/&amp;/g, '&').replace(/%40/g, '@'));
  const [ submitted, setSubmitted ] = useState(false);
  let invited_user_id = query.get('invite_id');
  let email = query.get('email');
  const { executeRecaptcha } = useGoogleReCaptcha();
  const {
    showV2Captcha,
    setShowV2Captcha,
    clientKeyV2
  } = useRecaptchaV2Hook();
  
  // reset login status
  useEffect(() => {
    if(isLoggedIn()){
      history.push('/');
      dispatch(alertActions.error(userConstants.LOGIN_ALREADY));
    }else{
      dispatch(userActions.logout());
      if(invited_user_id){
        dispatch(userActions.showInvitation(invited_user_id));
      } else if (email){
        dispatch(change('registerfom', 'email', email))
      }

    }
  }, []);

  useEffect(() => {
    if(executeRecaptcha){
      fetchToken();
    }
  }, [executeRecaptcha]);

  const fetchToken = async() =>{
      const token = await executeRecaptcha("submit_form");

      await dispatch(change('registerfom', 'recaptcha_token', token));
  }

  const handleV2Captcha = (token) => {
    dispatch(change('registerfom', 'recaptcha_token_v2', token));
  }

  const registerSubmit = async (values) => {
    if (!executeRecaptcha) return;
    
    const token = await executeRecaptcha("submit_form");

    await dispatch(change('registerfom', 'recaptcha_token', token));

    const successCallback = () => {
      setSubmitted(true)
    }

    const errorCallback = (response) => {
      if(response.data.show_v2_captcha){
        setShowV2Captcha(true);
        return
      }
    }

    dispatch(userActions.register(values, {errorCallback,successCallback}));
  }

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Free forever. Get more things done, less time wasted."
        />
      </Helmet>
      <main className="container-fluid min-vh-100 public-page-container">
        <Topbar />
        <Row className='justify-content-center'>
          <Col lg={5}>
            <div className='bordered-card'>
              <div className="bordered-card--body">
                <h3 className="font-weight-bold text-center mb-4">Create Account</h3>

                {
                  submitted ?
                    <div
                      className={'login_message text-center success my-3'}
                    >
                      {
                        invited_user_id ?
                          'You may now log in.'
                        :
                          'Check your email for confirmation.'
                      }
                    </div>
                  :
                    <>
                      <form
                        onSubmit={handleSubmit(registerSubmit)}
                        className={''}
                        autocomplete="off"
                      >
                        <Field name="invite_id" type="hidden" component={textInput} autocomplete="off" />

                        <div className="mb-2">
                          <Field name="first_name" type="text" component={textInput} label="First Name" autocomplete="off" />
                        </div>

                        <div className="mb-2">
                          <Field name="last_name" type="text" component={textInput} label="Last Name" autocomplete="off" />
                        </div>

                        { !invited_user_id && <div>

                          <div className="mb-2">
                            <Field name="email" type="email" component={textInput} label="Email Address" />
                          </div>
                        </div> }

                        <div className="mb-3">
                          <Field id="password" name="password" type="password" component={PasswordInput} label="Password" autocomplete="new-password" />
                        </div>

                        <div className="mb-3">
                          <Field id="password_confirmation" name="password_confirmation" type="password" component={PasswordInput} label="Confirm Password" autocomplete="new-password" />
                        </div>


                        <div className="mb-3 mt-4">
                          <div className="my-2 mt-4">
                            <AlertText />

                            {
                              showV2Captcha && 
                              <div className='d-flex justify-content-center'>
                                <ReCAPTCHA
                                  sitekey={clientKeyV2}
                                  type="image"
                                  onChange={handleV2Captcha}
                                />
                              </div>
                            }
                          </div>
                          <Button variant="brand" type="submit" className="full-width rounded-pill">Create account</Button>
                        </div>
                      </form>
                    </>
                }

                <div className="text-center">
                  <ul className="login-form__button-list">
                    <li><Link to="/login">Back to log in</Link></li>
                  </ul>
                </div>
              </div>
            </div>

          </Col> 
        </Row>
      </main>
    </>
  );
}

RregisterForm =  reduxForm({
  form: 'registerfom',
  validate: validation,
  enableReinitialize: true,
  touchOnBlur: false
})(RregisterForm);


const mapStateToProps = (state) => {
  const initialData = state.registration?.invited_user_info;
  return {
    user: state.authentication.user,
    initialValues: {
      invite_id: initialData?.token,
      first_name: initialData?.first_name,
      last_name: initialData?.last_name,
      email: initialData?.email,
      password: '',
      password_confirmation: '',
      recaptcha_token: ''
    }
  };
};

export default connect(mapStateToProps, { userActions })(RregisterForm);
